import { createActionsHook } from 'src/lib/sweetState';

import { CustomModelsStore } from './CustomModelsStore';

export const useCustomModelsActions = createActionsHook(CustomModelsStore);
